"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var react_helmet_1 = require("react-helmet");
function Preconnect(_a) {
    var hosts = _a.hosts;
    var preconnectLinks = hosts.map(function (host) { return (react_1.default.createElement("link", { key: host, rel: "dns-prefetch preconnect", href: "//" + host })); });
    return react_1.default.createElement(react_helmet_1.Helmet, null, preconnectLinks);
}
exports.default = Preconnect;
